import { useSrpContext } from '@/src/contexts'

import CheapestBooking from './cheapestBooking'

const CheapestBookingWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()

    const whenToBook = sections?.whenToBook
    if (!whenToBook?.bullets?.length) return null

    return (
        <CheapestBooking
            title={whenToBook.title}
            summary={whenToBook.summary}
            bullets={whenToBook.bullets}
        />
    )
}

export default CheapestBookingWrapper
